import { all, call } from '@redux-saga/core/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { goalTrackerActions } from './goalTrackerSlice';
import { goalTrackerApi } from '../../api/goalTrackerApi';
import { getUserInfoSaga } from '../profile/profileSagas';
import { IGoalTrackerForCardRewardResponse } from '../../components/GoalTracker/GoalTrackerTypes';

const SUCCESS_STATUS: number = 200;

function* confirmReward(action: PayloadAction<number>) {
  yield put(goalTrackerActions.setIsFetching(true));
  try {
    yield goalTrackerApi.confirmReward(action.payload);
    yield call(getUserInfoSaga);
  } catch (e) {
    yield put(goalTrackerActions.setErrorMessage('Sorry we can not handle this request'));
    console.error(e);
  } finally {
    yield put(goalTrackerActions.setIsFetching(false));
  }
}

function* getCurrentGoalTrackersForCardReward(action: PayloadAction<string | undefined>) {
  yield put(goalTrackerActions.setIsFetching(true));
  try {
    const response: IGoalTrackerForCardRewardResponse = yield goalTrackerApi.getTrackers(action.payload || 'all');
    if (response.status === SUCCESS_STATUS) {
      yield put(goalTrackerActions.setGoalTrackers(response));
    }
  } catch (e) {
    yield put(goalTrackerActions.setErrorMessage('Sorry we can not handle this request'));
    console.error(e);
  } finally {
    yield put(goalTrackerActions.setIsFetching(false));
  }
}

function* fetchUnreadGoalTrackersCount() {
  try {
    const response: { data: { count: number } } = yield goalTrackerApi.getUnreadCount();
    yield put(goalTrackerActions.setUnreadGoalTrackersCount(response.data.count));
  } catch (e) {
    console.error(e);
  }
}

function* markTrackerAsRead(action: PayloadAction<number>) {
  try {
    const response: { data: { marked: boolean } } = yield goalTrackerApi.markTrackerAsRead(action.payload);

    if (response.data.marked) {
      yield put(goalTrackerActions.decrementUnreadGoalTrackersCount());
    }
  } catch (e) {
    console.error(e);
  }
}

export function* watchGoalTrackerSagas() {
  yield all([
    takeLatest(goalTrackerActions.getCurrentGoalTrackersForCardReward, getCurrentGoalTrackersForCardReward),
    takeLatest(goalTrackerActions.fetchUnreadGoalTrackersCount, fetchUnreadGoalTrackersCount),
    takeLatest(goalTrackerActions.markTrackerAsRead, markTrackerAsRead),
    takeLatest(goalTrackerActions.confirmReward, confirmReward),
    call(fetchUnreadGoalTrackersCount),
    call(getCurrentGoalTrackersForCardReward, goalTrackerActions.getCurrentGoalTrackersForCardReward('registered')),
  ]);
}
